import React from 'react';
import { FormattedText } from 'core/i18n';

export const ResidentContainer = ({ visibility, handleOnClick, id }) => (
    <div className={visibility ? 'resident-restriction' : 'hidden'} id={id}>
        <div className="prospects-gutter prospects-separator">
            <div className="row">
                <div className="col-xs-12">
                    <i className="icons icons--icon-non-resident" />
                    <h5 className="font-heading5 resident-restriction__title">
                        <FormattedText value="initial-thankYouInterested" />
                    </h5>
                    <hr className="dash" />
                    <p className="font-paragraph2 resident-restriction__description">
                        <FormattedText value="initial-weRegretInconvenience" />
                    </p>
                    <div className="resident-restriction__phone-contact">
                        <i className="icons icons--icon-phone-blue" />
                        <p className="font-paragraph2 age-restriction__call-center">
                            <FormattedText value="initial-contactMessageNumber" />
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className="form__footer form__footer-inner">
            <div className="text-right">
                <button type="button" className="form__button form__button-secondary" onClick={handleOnClick}>
                    <FormattedText value="button-understood" />
                </button>
            </div>
        </div>
    </div>
);
